module.exports = __webpack_public_path__ + "img/inv_ro.96453e5d.webp";